<template>
  <ViewContainer v-if="sheet" :title="sheet.name">
    <template v-slot:heading>
      <slot name="title">
        <icon-button
          :value="faveIconState"
          @slotUpdated="toggleFavourite"
          class="text-accent inline-block mr-2 -ml-8"
          data-test="fave"
          :title="`${isFaved(sheet.id) ? `Remove from` : `Save to`} favourites`"
          v-show="loggedIn"
        >
          <icon
            class="opacity-60 fill-transparent stroke-current"
            data-id="star"
          />
          <icon slot="on" data-id="star" class="opacity-100" />
        </icon-button>
        <span>{{ sheet.name || `unnamed` }}</span>
      </slot>
    </template>

    <template v-slot:default>
      <form
        @submit.prevent
        action="/update"
        class="u-spaceitems pb-4"
        data-test="sheetForm"
        method="PUT"
      >
        <div class="text-center" data-test="initiative">
          <field :value="sheet.initiative || 0" @input="update" type="number">
            Initiative bonus:
          </field>
        </div>
      </form>
    </template>

    <template v-if="battle" v-slot:after>
      <a href="/" @click.prevent="$router.back()" class="py-4 inline-block">
        Go back
      </a>
      <span class="max-md:hidden"> (escape key)</span>
    </template>
  </ViewContainer>
</template>

<script>
import LabelledFieldInput from '@/components/LabelledFieldInput'
import IconButton from '@/components/IconButton'
import ViewContainer from '@/components/ViewContainer'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: `StatSheet`,
  components: {
    field: LabelledFieldInput,
    IconButton,
    ViewContainer,
  },

  props: {
    sheet: {
      type: Object,
      required: true,
    },
  },

  created() {
    this.subBackKeyHandler()
  },

  beforeDestroy() {
    this.unSubBackKeyHandler()
  },

  computed: {
    ...mapGetters(`accounts`, [`loggedIn`]),
    ...mapGetters(`battles`, [`battle`]),
    ...mapGetters(`favourites`, [`isFaved`]),

    faveIconState() {
      return this.isFaved(this.sheet.id) ? 1 : 0
    },
  },

  methods: {
    ...mapActions(`favourites`, [`fave`, `unfave`]),

    subBackKeyHandler() {
      document.addEventListener(`keyup`, this.backKeyHandler)
    },

    unSubBackKeyHandler() {
      document.removeEventListener(`keyup`, this.backKeyHandler)
    },

    backKeyHandler(e) {
      if (e.key === `Escape`) this.$router.go(-1)
    },

    toggleFavourite() {
      if (this.isFaved(this.sheet.id)) {
        this.unfave(this.sheet)
      } else {
        this.fave(this.sheet)
      }
    },

    update(value) {
      this.$emit(`update`, value)
    },

    // TODO: conditional so 'back' link only shows if same domain.
  },
}
</script>
